//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_DEPARTAMENTOS = "obtenerDepartamentos";
export const OBTENER_DEPARTAMENTO = "obtenerDepartamento";
export const REGISTRAR_DEPARTAMENTO = "registrarDepartamento";
export const ACTUALIZAR_DEPARTAMENTO = "actualizarDepartamento";
export const OBTENER_DEPARTAMENTOS_BY_PAIS = "obtenerDepartamentosByPais";

export const OBTENER_DEPARTAMENTOS_APROBADOR_REVISOR_PERIODO = "obtenerDepartamentosRevisorPeriodo";
export const OBTENER_DEPARTAMENTOS_APROBADOR_PERIODO = "obtenerDepartamentosAprobadorPeriodo";
// mutation types
export const SET_DEPARTAMENTOS = "setDepartamentos";
export const SET_DEPARTAMENTO = "setDepartamento";

const state = {
    departamentos: [],
    departamento:[],
}

const getters = {
    obtenerDepartamentos(state) {
      return state.asesores;
    },
}

const actions = {
    async [OBTENER_DEPARTAMENTOS](context, estadoId) {

        /*
        * Si el estado es null va a traer a todos los departamentos, de lo contrario va a traer los departamentos por estado
        *
        */
        let endpoint = 'api/Departamentos'
        if(estadoId){
            endpoint = `api/Departamentos/Estado/${estadoId}`
        }

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_DEPARTAMENTOS, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },

    async [OBTENER_DEPARTAMENTOS_BY_PAIS](context, paisId) {

        /*
        * Si el estado es null va a traer a todos los departamentos, de lo contrario va a traer los departamentos por estado
        *
        */
        let endpoint = 'api/Departamentos'
        if(paisId){
            endpoint = `api/Departamentos/GetDepartamentosByPais/${paisId}`
        }

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_DEPARTAMENTOS, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },

    async [OBTENER_DEPARTAMENTO](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Departamentos/`)
                .then(({ data }) => {
                    context.commit(SET_DEPARTAMENTO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    


    },
    async [REGISTRAR_DEPARTAMENTO](context, datosDepto){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Departamentos`, datosDepto)
                .then(({ data }) => {
                    context.commit(SET_DEPARTAMENTO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    },
    async [ACTUALIZAR_DEPARTAMENTO](context, datosDepto){
        let id = datosDepto.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/Departamentos/`, datosDepto)
                .then(({ data }) => {
                    context.commit(SET_DEPARTAMENTO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },

    async [OBTENER_DEPARTAMENTOS_APROBADOR_REVISOR_PERIODO](context, datos) {

        let endpoint = `api/Departamentos/Revisor/Periodo/${datos.aprobadorRevisorId}/${datos.periodoId}`
       

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_DEPARTAMENTOS, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },


    /**
     * Obtener los departamentos asignados a un aprobaodr por periodo
     * @param {*} context 
     * @param {*} datos 
     * @returns 
     */
    

    async [OBTENER_DEPARTAMENTOS_APROBADOR_PERIODO](context, datos) {

        let endpoint = `api/Departamentos/Aprobador/Periodo/${datos.aprobadorRevisorId}/${datos.periodoId}`
       

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_DEPARTAMENTOS, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },
  }

const mutations = {
    [SET_DEPARTAMENTOS](state, data) {
        state.departamentos = data;
    },

    [SET_DEPARTAMENTO](state, data) {
        state.departamento = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}